import { render } from "./datenschutz.vue?vue&type=template&id=4df38b58"
import script from "./datenschutz.vue?vue&type=script&lang=js"
export * from "./datenschutz.vue?vue&type=script&lang=js"

import "./datenschutz.vue?vue&type=style&index=0&id=4df38b58&lang=scss"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__